export default __webpack_public_path__ + "static/media/pl.cd835d05.svg";